export const SEARCH_LAYOUT_COOKIE = 'searchLayout';
export const NEVER_EXPIRE_COOKIE_TIME = '01-01-2100 00:00:00';
export const EXPIRE_IMMEDIATE_COOKIE_TIME = '01-01-1970 00:00:00';
export const CART_COUNT_COOKIE = 'cart-icon';
export const NEWLY_REGISTERED_COOKIE = 'newlyRegistered';
export const OPAL_PROFILE_COOKIE = 'profile';
export const SEARCH_BEST_FOR_YOU_COOKIE = '__bfu';
export const SEARCH_COLOR_SWATCHES_COOKIE = '__crss';
export const DROP_COOKIE = 'zd';
export const CLOSED_LA_COOKIE = 'clac';
